import { getTradeHistory } from '@/services/home';
import { TradeHistoryItem } from '@/types';
import {
  Modal,
  Table,
  // TableErrorEnum,
  // TableErrorType,
  Pagination,
} from '@bfe/moly';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useMemo, useState } from 'react';
import { useWallet } from '@/hooks/wallet';
import { useFm } from '@web3/base-hooks';

type IPointsGetHistory = {
  visble: boolean;
  onOk?: () => void;
  onCancel?: () => void;
};
export const PointsGetHistory = (props: IPointsGetHistory) => {
  const { visble } = props;
  const { walletId, walletType } = useWallet();
  const fm = useFm();
  const [fromId, setFromId] = useState(0);
  const limit = 11; // 请求数据条数
  const dataLimit = limit - 1; // 显示数据条数比请求条数少1
  const [page, setPage] = useState(1);
  // const [direct, setDirect] = useState<-1 | 1>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const columns: ColumnDef<TradeHistoryItem>[] = [
    // {
    //   accessorKey: 'orderId',
    //   header: ({ column }) => <div>{column.id}(Order ID)</div>,
    // },
    {
      accessorKey: 'amount',
      header: fm('transactionAmount'),
    },
    {
      accessorKey: 'point',
      header: fm('obtainedPoints'),
    },
    {
      accessorKey: 'time',
      // header: '时间（UTC）',
      header: ({ column }) => <div className="text-right">{fm('timeUtc')}</div>,
      cell: ({ row }) => {
        // const date = new Date(row.getValue('time'));
        return <div className="text-right">{row.getValue('time')}</div>;
      },
    },
  ];
  const [data, setData] = useState<TradeHistoryItem[]>([]);
  const fetchData = async (direct) => {
    // console.log('direct===>', direct, data);
    const params: any = {
      walletId,
      walletType,
      limit,
    };
    if (direct != 0) {
      params.direct = direct;
      params.fromId = direct > 0 ? data[limit - 1]?.id : data[0]?.id;
      setPage(direct > 0 ? page + 1 : page - 1);
    } else {
      params.fromId = 0;
      setPage(1);
    }
    setFromId(params.fromId);

    try {
      setLoading(true);
      const res = await getTradeHistory(params);
      if (res.success) {
        setData(res.result);
        if (res.result.length < limit && direct === -1) {
          fetchData(0);
        }
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const showData = useMemo(() => data.slice(0, dataLimit), [data, dataLimit]);

  useEffect(() => {
    if (visble && walletId) {
      fetchData(0);
    } else {
      setData([]);
      setFromId(0);
    }
  }, [visble, walletId]);
  return (
    <Modal
      title={fm('transPointsRec')}
      footer={null}
      open={props.visble}
      onCancel={props.onCancel}
    >
      <Table
        columns={columns}
        data={showData}
        loading={loading}
        emptyText={fm('noTransactionRecord')}
      ></Table>
      {(fromId !== 0 || (fromId == 0 && showData.length === dataLimit)) && (
        <div className=" mt-6">
          <Pagination
            align="right"
            isStairs
            prevText={fm('prevPage')}
            nextText={fm('nextPage')}
            disabledPrev={page === 1}
            disabledNext={showData.length < dataLimit}
            onChangeStairs={(type) => {
              console.log(type);
              fetchData(type === 'next' ? 1 : -1);
            }}
          />
        </div>
      )}
    </Modal>
  );
};
